var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEngineeringLogistic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 60,
    viewBox: "0 0 76 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9195 54H12.386C10.1959 54 8.41344 52.2175 8.41344 50.0274V11.0388H67.8868V50.0274C67.8868 52.2175 66.1044 54 63.9143 54H63.9195ZM10.2481 12.8683V50.0274C10.2481 51.2087 11.2099 52.1705 12.3912 52.1705H63.9247C65.1061 52.1705 66.0678 51.2087 66.0678 50.0274V12.8683H10.2534H10.2481Z",
    fill: "#5A2FDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2206 44.5601H24.3822V46.3895H59.2206V44.5601Z",
    fill: "#5A2FDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8297 46.3894H46.9003V23.7876H54.8297V46.3894ZM48.7297 44.5599H53.0002V25.6171H48.7297V44.5599Z",
    fill: "#5A2FDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7296 46.3894H40.8002V27.5615H48.7296V46.3894ZM42.6297 44.5599H46.9002V29.391H42.6297V44.5599Z",
    fill: "#5A2FDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6299 46.3893H34.7005V31.21H42.6299V46.3893ZM36.5247 44.5599H40.7952V33.0394H36.5247V44.5599Z",
    fill: "#5A2FDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5244 46.3895H28.595V34.4404H36.5244V46.3895ZM30.4245 44.56H34.695V36.2699H30.4245V44.56Z",
    fill: "#5A2FDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9242 12.8683H2V6H73.9242V12.8683ZM3.82947 11.0389H72.0948V7.82947H3.82947V11.0389Z",
    fill: "#5A2FDE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEngineeringLogistic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Engineering-Logistic.a3df844b.svg";
export { ForwardRef as ReactComponent };